<template>
  <v-dialog
    max-width="400"
    :value="true"
    @click:outside="$emit('cancel')">
    <v-card>
      <v-card-title>
        <h2>Delete this {{ itemName }}?</h2>
      </v-card-title>
      <v-card-text>
        <p>
          Are you sure you want to delete this {{ itemName }}? This cannot be undone.
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <button
          class="default-btn red"
          @click="$emit('confirm')">
          Delete
        </button>

        <button
          class="default-btn text"
          @click="$emit('cancel')">
          Cancel
        </button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmRemoveProvider',
  props: {
    itemName: String,
  },
}
</script>

<style lang="scss" scoped>

</style>
